import { useMemo } from 'react'
import { useSuspenseQuery } from '@apollo/client/react'
import { AdminAPI, getFragment, SharedAPI } from '@guestgoodie/graphql'

export default function useOrganization() {
  const { data } = useSuspenseQuery(AdminAPI.organization.GET)

  const organization = useMemo(
    () =>
      getFragment(
        SharedAPI.organization.ORGANIZATION_FRAGMENT,
        data.getOrganization
      ),
    [data]
  )

  const appUrl = useMemo(() => {
    return `https://${organization.slug}.${location.host}`
  }, [organization])

  return {
    organization,
    appUrl
  }
}
